export const TO_USER = 'TO_USER'
export const TO_GROUP = 'TO_GROUP'
export const TO_ME = 'TO_ME'

export const ASSIGN_OPTIONS = [
  { label: 'Atribuir à um usuário', value: TO_USER },
  { label: 'Atribuir à um grupo', value: TO_GROUP },
  { label: 'Atribuir à mim', value: TO_ME }
]

export const ASSIGN_LABELS = {
  TO_USER: 'Novo usuário',
  TO_GROUP: 'Novo grupo',
  TO_ME: ''
}
